import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {LivePenaltiesModuleState} from "../models/live-penalties-module.state";
import {LIVE_PENALTIES} from "../live-penalties-module.consts";
import {AthleteChartEventsViewModel} from "../../../domain/full-game/models/chart-events/athlete-chart-events/athlete-chart-events.view-model";
import type {LivePenaltiesModuleController} from "../live-penalties-module.controller";

export class LivePenaltiesModulePlayerChangeHandler extends ActionHandler {
  controller: LivePenaltiesModuleController;
  state: LivePenaltiesModuleState;
  type = LIVE_PENALTIES.ACTION_TYPES.onPlayerChange;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.state.selectedPlayerIndex = this.state.athletesChartEvents.findIndex((athlete: AthleteChartEventsViewModel) => athlete.athleteId === params.athleteId);

    this.controller.action(LIVE_PENALTIES.ACTION_TYPES.onPlayerSwipe, {
      gameId: this.controller.props.gameId,
      competitorId: this.state.competitorVM.id,
      athleteId: this.state.selectedAthlete.id
    })
  }
}
